<template>
  <div class="footer-container">
    <div class="auto-marketer">
      <img :src="require('@/assets/images/profile/logo-white.png')" alt="Logo" class="logo">
      <div class="certificate-of-registration-copyright-wrapper">
        <span class="certificate-of-registration">Cвидетельство о регистрации СМИ «Автомаркетолог» Эл №ФС77-47104 от 29 октября 2011 года, зарегистрирован Федеральной службой по надзору в сфере связи, информационных технологий и массовых коммуникаций (Роскомнадзор). Возрастная классификация «18+».</span>
        <span class="copyright">© ООО «АВТОМАРКЕТОЛОГ», 2012-{{ currentYear }}</span>
      </div>
    </div>

    <div class="sections">
      <span class="sections-title">Разделы</span>
      <div class="sections-wrapper">
        <span
            v-for="(section, idx) in sections.filter(s => s.active)"
            :key="idx"
        >
          <a :href="section.url">
            {{ section.name }}
          </a>
        </span>
      </div>

    </div>

    <div class="social-media">
      <div>
        <span class="social-media-title">Социальные сети</span>
        <div class="social-media-icons">
          <a
              v-for="(icon, idx) in socialMediaIcons"
              :key="idx"
              :href="icon.url"
              target="_blank"
              rel="noopener noreferrer"
          >
            <img
                :src="icon.src"
                :alt="icon.alt"
            >
          </a>
        </div>
      </div>
      <a href="/privacy-policy" class="privacy-policy">Политика конфиденциальности</a>
    </div>
  </div>
</template>

<script>
import XLogo from '@/assets/images/soc_networks_dark_theme/X Logo.svg';
import YouTubeLogo from '@/assets/images/soc_networks_dark_theme/Logo Youtube.svg';
import TelegramLogo from '@/assets/images/soc_networks_dark_theme/Telegram Logo.svg';

export default {
  name: "MainFooter",
  data() {
    return {
      sections: [
        { name: 'О проекте', url: '/about', active: false },
        { name: 'СМИ', url: 'https://automarketolog.ru', active: true },
        { name: 'Чат', url: '/chat', active: true },
        { name: 'Отчёты', url: '/reports', active: true },
        { name: 'Мероприятия', url: '/events', active: false },
        { name: 'Сообщество', url: '/community', active: false },
        { name: 'Партнеры', url: '/partners', active: false },
        { name: 'Контакты', url: '/contacts', active: false },
      ],
      socialMediaIcons: [
        { src: YouTubeLogo, alt: 'YouTube Logo', class: 'youtube', url: 'https://youtube.com/@automarketolog' },
        { src: TelegramLogo, alt: 'Telegram Logo', class: 'telegram', url: 'https://t.me/automarketolog_ru' },
        { src: XLogo, alt: 'X Logo', class: 'x', url: 'https://x.com/automarketolog' },
      ],
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style>
.footer-container {
  height: 344px;
  background-color: #23282c;
  display: flex;
  justify-content: space-between;
  padding: 40px 108px 64px 108px;
}

.auto-marketer {
  width: 394px;
  height: 240px;
  display: flex;
  flex-direction: column;
}

.certificate-of-registration-copyright-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.logo {
  height: 40px;
  width: 338px;
  margin-bottom: 20px;
}

.certificate-of-registration, .copyright {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #FFFFFF;
}

.certificate-of-registration {
  margin-bottom: 96px;
}

.sections-title, .social-media-title {
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
  color: #FFFFFF;
}

.social-media-icons {
  margin-top: 12px;
}

.sections-wrapper {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  gap: 12px;
}

.sections-wrapper a {
  text-decoration: none;
  color: inherit;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 0 0 104px;
  color: #FFFFFF;
}

.social-media {
  width: 394px;
  height: 240px;
  display: flex;
  flex-direction: column;
  gap: 150px;
  padding: 20px 0 0 106px;
}

.social-media-icons {
  display: flex;
  gap: 20px;
}


.privacy-policy {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #FFFFFF;
}

</style>
